import { useCallback, useState } from 'react';
import { FUNDRAISING_SORT_KEYS } from 'features/IRWorkstation/constants/fundraisingColumns';

const SORT_STORAGE_KEY = 'fundraisingPipeline:sort';

const EMPTY_SORT = { sortBy: null, sortDir: 'asc' };

// A stored column that no longer exists (or a corrupt entry) falls back to the
// API default ordering rather than sending an unknown column.
const readStoredSort = () => {
	try {
		const stored = JSON.parse(localStorage.getItem(SORT_STORAGE_KEY));

		if (!FUNDRAISING_SORT_KEYS.includes(stored?.sortBy)) return EMPTY_SORT;

		return {
			sortBy: stored.sortBy,
			sortDir: stored.sortDir === 'desc' ? 'desc' : 'asc',
		};
	} catch {
		return EMPTY_SORT;
	}
};

// Sort state for the LP Pipeline table. Persisted in localStorage so it survives
// navigation and reloads, matching how the Active Raise panel pins an entity.
const useFundraisingSort = () => {
	const [sort, setSort] = useState(readStoredSort);

	// First click on a column sorts ascending, clicking the active column again
	// flips to descending.
	const toggleSort = useCallback((sortKey) => {
		if (!FUNDRAISING_SORT_KEYS.includes(sortKey)) return;

		setSort((current) => {
			const next = {
				sortBy: sortKey,
				sortDir:
					current.sortBy === sortKey && current.sortDir === 'asc'
						? 'desc'
						: 'asc',
			};

			localStorage.setItem(SORT_STORAGE_KEY, JSON.stringify(next));

			return next;
		});
	}, []);

	return { sort, toggleSort };
};

export { SORT_STORAGE_KEY };
export default useFundraisingSort;
